import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-scenario mb-4" }
const _hoisted_2 = { class: "card-body text-center" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2 mb-3"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-2 mb-3"
}
const _hoisted_5 = {
  id: "solveText",
  class: "mx-5 mb-3"
}
const _hoisted_6 = {
  key: 2,
  class: "mt-2 mb-3"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 3,
  class: "mt-2 mb-3"
}
const _hoisted_9 = { id: "guaranteedIncomeUptakeText1" }
const _hoisted_10 = {
  key: 4,
  class: "mt-2 mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_solve_buttons = _resolveComponent("solve-buttons")!
  const _component_help = _resolveComponent("help")!
  const _component_guaranteed_income_checker = _resolveComponent("guaranteed-income-checker")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("i", {
            class: _normalizeClass(["bi fs-1", _ctx.exclaimationOrCheck])
          }, null, 2),
          _createElementVNode("h3", {
            class: _normalizeClass(_ctx.textClass)
          }, "Scenario " + _toDisplayString(_ctx.number), 3),
          _createElementVNode("p", null, _toDisplayString(_ctx.scenarioName), 1)
        ]),
        _createElementVNode("div", null, [
          (_ctx.showGraphButton)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "bi fs-4 bi-bar-chart-fill text-secondary float-end me-1",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowGraphsClicked && _ctx.onShowGraphsClicked(...args)))
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showSolvePass)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[6] || (_cache[6] = [
              _createElementVNode("div", null, [
                _createElementVNode("p", { class: "mx-5 mb-3" }, " Your plan would still be expected to work, although you may need to dip into your protected pot if you have one. ")
              ], -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.showSolveFail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.failedScenarioText), 1),
                _createVNode(_component_solve_buttons, {
                  ref: "solveButtons",
                  onSolveTakeLess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('solve-take-less', _ctx.scenario))),
                  onSolvePayMore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('solve-pay-more', _ctx.scenario))),
                  onSolveEquityRelease: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('solve-equity-release', _ctx.scenario))),
                  scenario: _ctx.scenario
                }, null, 8, ["scenario"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showGuaranteedIncomeOffer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createElementVNode("p", {
                  id: "guaranteedIncomeText",
                  class: "mx-5 mb-3"
                }, " Your plan works, but there is always a risk the future won't be exactly as expected. You can see what may happen if you buy some guaranteed income. This will reduce the risk of running out of money if things don't go to plan. ", -1)),
                _createElementVNode("button", {
                  class: "btn btn-success mx-3",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onExamineGuaranteedIncome && _ctx.onExamineGuaranteedIncome(...args))),
                  disabled: _ctx.disableButtons
                }, " Let's see ", 8, _hoisted_7)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showGuaranteedIncomeUptake)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.guaranteedIncomeUptakeText) + " ", 1),
                  _createVNode(_component_help, {
                    title: "Guaranteed income",
                    text: _ctx.HelpText.guaranteedIncome(_ctx.annuityType)
                  }, null, 8, ["text"])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mb-3",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onUnsubscribeGuaranteedIncomeClicked($event)))
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("span", { class: "d-none d-sm-inline-block me-2" }, "Remove", -1),
                  _createElementVNode("i", { class: "bi bi-dash-circle" }, null, -1)
                ])),
                _cache[9] || (_cache[9] = _createElementVNode("p", { id: "guaranteedIncomeUptakeText2" }, [
                  _createElementVNode("b", null, "Don't stop here."),
                  _createTextVNode(" See what happens if things don't go as expected in the next page, then see all your plan details on our Finish page. ")
                ], -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFinishEncouragement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[10] || (_cache[10] = [
              _createElementVNode("div", null, [
                _createElementVNode("p", { id: "finishEncouragementText" }, [
                  _createTextVNode(" If everything turns out as expected your pots should not run out. "),
                  _createElementVNode("b", null, "Don't stop here."),
                  _createTextVNode(" See what happens if things don't go as expected in the next page, then see all your plan details in our Finish page. ")
                ])
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_component_modal, {
      ref: "guaranteedIncomeModal",
      title: "Guaranteed income",
      idKey: 'guaranteedIncomeModal' + _ctx.scenario,
      key: 'guaranteedIncomeModal' + _ctx.scenario
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_guaranteed_income_checker, {
          ref: "guaranteedIncomeChecker",
          onCheckFinished: _ctx.onGuaranteedIncomeCheckFinished,
          key: 'guaranteedIncomeChecker' + _ctx.scenario
        }, null, 8, ["onCheckFinished"]))
      ]),
      _: 1
    }, 8, ["idKey"]))
  ], 64))
}